import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getQuestion, saveQuestion, updateQuestion } from './QuestionService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const QuestionDetail = (): JSX.Element => {
  const [questionContent, setQuestionContent] = useState('');
  const [exampleAnswer, setExampleAnswer] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const { questionid } = useParams<{ questionid: string }>();
  // const [loading, setLoading] = useState(false);

  function clearQuestionDetailsForm() {
    setQuestionContent('');
    setExampleAnswer('');
    setStatus('');
  }

  const cancelSaveOrUpdateQuestion = () => {
    clearQuestionDetailsForm();
    navigate('/system/dashboard/questions');
  };

  function saveOrUpdateQuestion(e) {
    e.preventDefault();

    const question = {
      questionContent,
      exampleAnswer,
      status,
    };

    if (questionid) {
      const questionIdAsNumber: number = parseInt(questionid);
      updateQuestion(questionIdAsNumber, question)
        .then(() => {
          navigate('/system/dashboard/questions');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveQuestion(question)
        .then(() => {
          navigate('/system/dashboard/questions');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (questionid) {
      const questionIdAsNumber: number = parseInt(questionid);
      console.log('questionid exists: ', questionid);
      getQuestion(questionIdAsNumber)
        .then((response) => {
          console.log(response.data);
          setQuestionContent(response.data.questionContent);
          setExampleAnswer(response.data.exampleAnswer);
          setStatus(response.data.status);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [questionid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/system/dashboard/sections"
            >
              Questions
            </Link>
            <Typography color="text.primary">Question Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Question Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Question Content
                </Typography>
                <TextField
                  variant="outlined"
                  name={'name'}
                  fullWidth
                  value={questionContent} // Use the 'sequence' state variable as the value
                  onChange={(event) => setQuestionContent(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Example Answer
                </Typography>
                <TextField
                  variant="outlined"
                  name={'name'}
                  fullWidth
                  value={exampleAnswer} // Use the 'sequence' state variable as the value
                  onChange={(event) => setExampleAnswer(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status}
                  onChange={(event) => setStatus(event.target.value)}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateQuestion}>Cancel</Button>
                  <Button onClick={saveOrUpdateQuestion}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default QuestionDetail;
